type SignupAddonPriceIdsInput = {
  isNutritionCoachingAdded?: boolean;
  nutritionCoachingPriceId?: string | null;
  isSupplementAdded?: boolean;
  supplementPackPriceId?: string | null;
};

type ChallengeNutritionUpsellInput = {
  isChallengePackageFlow: boolean;
  isAustraliaUser: boolean;
  nutritionCoachingPriceId?: string | null;
  nutritionCoachingPrice?: number;
};

type TrackedPurchasePriceIdsInput = {
  mainPriceId?: string | null;
  isPersonalCoachingAdded?: boolean;
  personalCoachPriceId?: string | null;
  isNutritionCoachingAdded?: boolean;
  nutritionCoachingPriceId?: string | null;
  isSupplementAdded?: boolean;
  supplementPackPriceId?: string | null;
  additionalPriceIds?: string[];
};

export const buildSignupAddonPriceIds = ({
  isNutritionCoachingAdded,
  nutritionCoachingPriceId,
  isSupplementAdded,
  supplementPackPriceId,
}: SignupAddonPriceIdsInput): string[] => {
  const addonPriceIds: string[] = [];

  if (isNutritionCoachingAdded && nutritionCoachingPriceId) {
    addonPriceIds.push(nutritionCoachingPriceId);
  }

  if (isSupplementAdded && supplementPackPriceId) {
    addonPriceIds.push(supplementPackPriceId);
  }

  return addonPriceIds;
};

export const shouldPurchaseSignupAddonsSeparately = ({
  bundledAddonPriceIds,
  mainPurchaseBundlesAddonPriceIds,
  walletPaymentIntentId,
}: {
  bundledAddonPriceIds: string[];
  mainPurchaseBundlesAddonPriceIds: boolean;
  walletPaymentIntentId?: string;
}): boolean => {
  if (walletPaymentIntentId) {
    return false;
  }

  if (bundledAddonPriceIds.length === 0) {
    return false;
  }

  return !mainPurchaseBundlesAddonPriceIds;
};

export const shouldShowChallengeNutritionUpsell = ({
  isChallengePackageFlow,
  isAustraliaUser,
  nutritionCoachingPriceId,
  nutritionCoachingPrice = 0,
}: ChallengeNutritionUpsellInput): boolean =>
  isChallengePackageFlow &&
  isAustraliaUser &&
  Boolean(nutritionCoachingPriceId) &&
  nutritionCoachingPrice > 0;

export const buildTrackedPurchasePriceIds = ({
  mainPriceId,
  isPersonalCoachingAdded,
  personalCoachPriceId,
  isNutritionCoachingAdded,
  nutritionCoachingPriceId,
  isSupplementAdded,
  supplementPackPriceId,
  additionalPriceIds = [],
}: TrackedPurchasePriceIdsInput): string[] =>
  Array.from(
    new Set(
      [
        mainPriceId,
        ...(isPersonalCoachingAdded && personalCoachPriceId
          ? [personalCoachPriceId]
          : []),
        ...(isNutritionCoachingAdded && nutritionCoachingPriceId
          ? [nutritionCoachingPriceId]
          : []),
        ...(isSupplementAdded && supplementPackPriceId
          ? [supplementPackPriceId]
          : []),
        ...additionalPriceIds,
      ].filter(Boolean) as string[]
    )
  );
